<template>
	<div class="camp_list_container">
		<div class="date-panel">
			
			<el-collapse v-model="activeName" accordion>
			  <el-collapse-item :name="item.year" v-for="(item,index) in yearData">
				<template slot="title">
					<div class="year">{{item.year}}</div>
				</template>
			   <div class="month" 
			   :class="{'fill': tem.month > 12,'disabled':tem.total == 0,'border-r': tem.month % 2 ==1 ,'border-b-none':tem.month == 11 || tem.month == 12}" 
			   v-for="(tem,dex) in item.month_list" @click="scrollToAnchor(tem.value)">
					<a>{{tem.lable}}</a>
			   </div>
			  </el-collapse-item>
			</el-collapse>
			
		</div>
		
		
		<div class="camp_items">
			<div class="camp_item" v-if="productData.list" :id="item.year+'-'+item.month"
				v-for="(item,index) in productData.list" @click="toDetail(item)">
				<!-- <div v-if="hover_index!=1" class="mask"></div> -->
				<img class="cover" :src="item.img_url"/>
				<div class="camp_info">
					<div class="date">
						<div class="month">{{item.month}}月</div>
						<div class="year">{{item.year}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";


	export default {
		data() {
			return {
				activeName:'',
				hover_index: null,
				search: {
					page_index: 1,
					page_size: 100,
					order_by: ''
				},
				productData: {
					total: 0,
					count: 0,
					list: []
				},
				yearData:[],
			};
		},
		created() {
			document.title = "教师特训营 - 机工教师特训营";
			this.yearDataGet();
			this.productDataGet(1);
		},
		methods: {
			hoverClick(index) {
				this.hover_index = index;
			},
			outClick() {
				this.hover_index = null;
			},
			toDetail(item) {
				if (!item.id) {
					this.$alert('特训营正在紧张筹备中，敬请期待······', '温馨提示', {
						confirmButtonText: '确定'
					});
					return;
				}
				this.GoToDetail(item.product_type, item.id);
			},
			yearDataGet(){
				var that = this;
				var url = apiUrl.tt_camp_year_list_get;
				this.Ajax(url, {}, (data) => {
					that.yearData = data;
					that.activeName= data[0].year;
				});
			},
			productDataGet(index) {
				var that = this;
				if (index <= 1) {
					that.search.page_index = 1;
					that.productData.total = 1;
				}
				if (that.search.page_index > that.productData.total) {
					return;
				}
				that.search.page_index = index;
				var url = apiUrl.tt_camp_list_get;
				this.Ajax(url, this.search, (data) => {
					that.productData.list = data.list;
					that.productData.total = data.total;
					that.productData.count = data.count;
				});
			},
			scrollToAnchor(id) {
				const element = document.getElementById(id);
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}
		},
	};
</script>


<style lang="scss" scoped>
	.camp_list_container {
		width: 100%;
		min-height: 100vh;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		
		.camp_items{
			width: 100%;
			display: flex;
			flex-direction: column;
			
			.camp_item {
				cursor: pointer;
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				position: relative;
			
				.mask {
					display: block;
					width: 100%;
					min-height: 100%;
					background-color: rgba(187, 187, 187, 0.4);
					position: absolute;
					top: 0;
					left: 0;
					z-index: 2;
					cursor: pointer;
				}
				
				.cover{
					width: 100%;
				}
			
				.camp_info {
					width: 1200px;
					display: inline-flex;
					position: absolute;
					top: 0;
			
					.date {
						width: 52px;
						height: 58px;
						display: inline-flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						background-color: #F6892E;
						color: #fff;
						font-weight: 600;
						box-sizing: border-box;
						
						.month {
							font-size: 22px;
							border-bottom: 2px solid #fff;
						}
						
						.year{
							font-size: 15px;
						}
					}
				}
			
			}
		}
		

		.opacity-mask {
			//opacity: 0.7;
			//filter: grayscale(100%);
		}

		.date-panel {
			width: 80px;
			position: fixed;
			top: 120px;
			right: 65px;
			background-color: #fff;
			z-index: 99;
			border-radius: 10px;
			box-shadow: 0 5px 30px 0 rgba(46, 49, 72, .06);
			
			/deep/.el-collapse{
				border-top: none;
				border-bottom: none;
				border-radius: 10px;
			}
			
			/deep/.el-collapse-item__content{
				padding-bottom: 0 !important;
				display: flex;
				flex-wrap: wrap;
			}
			
			/deep/.el-collapse-item:first-child .el-collapse-item__header{
				border-radius: 10px 10px 0 0 !important;
			}
			/deep/.el-collapse-item:last-child .el-collapse-item__header{
				border-radius: 0 0 10px 10px !important;
			}
			/deep/.el-collapse-item:last-child .el-collapse-item__header.is-active{
				border-radius: 0 0 0 0 !important; 
			}
			
			/deep/.el-collapse-item:last-child.is-active .el-collapse-item__wrap{
				border-radius: 0 0 10px 10px !important;
			}
			
			/deep/.el-collapse-item__header.is-active{
				border-bottom-color: #eee !important;
			}
			.year {
				font-size: 18px;
				font-weight: 600;
				box-sizing: border-box;
				width: 100%;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				//border-bottom: 1px solid #eee;
			}
			
			.month {
				font-size: 14px;
				width: 50%;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-bottom: 1px solid #eee;
				cursor: pointer;

				a {
					color: #666;
				}

				&.border-r {
					border-right: 1px solid #eee;
				}

				&.border-b-none {
					border-bottom: none !important;
					//border-radius: 0 0 10px 10px;
				}

				&.fill {
					font-size: 18px !important;
					width: 100% !important;
				}

				&.disabled {
					a {
						color: rgba(0, 0, 0, 0.3) !important;
					}
				}

				&:not(.disabled):hover,
				&.actived {
					color: #F28B3B !important;
					background-color: #eee;

					a {
						color: #F28B3B !important;
					}
				}
			}
		}
	}
</style>